export default __webpack_public_path__ + "static/spitz-video-mobile-1cc0fac0f15e4133052b2fc5568f5a84.jpg";